import { render, staticRenderFns } from "./28.vue?vue&type=template&id=5d8eb931&scoped=true&"
import script from "./28.vue?vue&type=script&lang=js&"
export * from "./28.vue?vue&type=script&lang=js&"
import style0 from "./28.vue?vue&type=style&index=0&id=5d8eb931&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8eb931",
  null
  
)

export default component.exports